<div class="dashboard-container" fxLayout="column">
  <div class="referral-system panel" fxLayout="column">
    <div class="head d-flex justify-content-between align-items-center">
      <div class="title">
        <h4 class="mb-0">سیستم امتیاز دهی</h4>
      </div>
      <button
        mat-button
        (click)="getReferralCode()"
        color="warn"
        class="more"
        fxLayout="row"
      >
        <div class="d-flex">
          <span>دریافت لینک دعوت </span>
          <jam-icon name="chevron-left" />
        </div>
      </button>
    </div>
    <div class="body" fxLayout="row wrap" fxLayoutAlign="space-between center">
      <div>
        با کلیک روی دکمه دریافت لینک دعوت و اشتراک گذاری لینک با دوستان
        می‌توانید با عضویت اعضا و خرید آن‌ها امتیاز دریافت کنید و از امتیاز خود
        استفاده کنید.
      </div>
      <div class="referal-link d-flex align-items-center gap-2" *ngIf="referralLink">
        <a [href]="referralLink">{{ referralLink }}</a>
        <button mat-button [cdkCopyToClipboard]="referralLink" (click)="copyLink()">کپی</button>
      </div>
    </div>
  </div>

  <div class="my-orders panel" fxLayout="column">
    <div class="head d-flex justify-content-between align-items-center">
      <div class="title">
        <h4 class="mb-0">سفارش‌های من</h4>
      </div>
      <button
        [routerLink]="['my-orders']"
        mat-button
        color="primary"
        class="more"
        fxLayout="row"
      >
        <div class="d-flex">
          <span>مشاهده همه </span>
          <jam-icon name="chevron-left" />
        </div>
      </button>
    </div>
    <div
      class="body"
      fxLayout="row wrap"
      fxLayoutAlign.lt-md="center center"
      fxLayoutAlign="space-between center"
    >
      <div
        class="info-block waiting-price"
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign="center center"
      >
        <div class="logo">
          <img
            src="../../../../../assets/image/wating-price-calculation.svg"
            alt=""
          />
        </div>
        <div class="data">
          <div class="count">
            {{ (dashboardInfo | async)?.totalCalculation || 0 | digitsEnToFa }}
            سفارش
          </div>
          <div class="label">در حال استعلام قیمت</div>
        </div>
      </div>

      <div
        class="info-block waiting-price"
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign="center center"
      >
        <div class="logo">
          <img src="../../../../../assets/image/printing.svg" alt="" />
        </div>
        <div class="data">
          <div class="count">
            {{ (dashboardInfo | async)?.totalProgress || 0 | digitsEnToFa }}
            سفارش
          </div>
          <div class="label">در حال اجرا</div>
        </div>
      </div>

      <div
        class="info-block waiting-price"
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign="center center"
      >
        <div class="logo">
          <img src="../../../../../assets/image/delivered.svg" alt="" />
        </div>
        <div class="data">
          <div class="count">
            {{ (dashboardInfo | async)?.totalDelivered || 0 | digitsEnToFa }}
            سفارش
          </div>
          <div class="label">سفارش‌های تحویل داده شده</div>
        </div>
      </div>
    </div>
  </div>
  <div class="activity-manage panel" fxLayout="column">
    <div class="head" fxLayout="row" fxLayoutAlign="space-between start">
      <div class="title">
        <h4 class="mb-0">مدیریت فعالیت‌ها</h4>
      </div>
    </div>
    <div
      class="body"
      fxLayout="row wrap"
      fxLayout.lt-md="column"
      fxLayoutAlign="space-between center"
      fxLayoutAlign.lt-md="center center"
    >
      <div
        class="info-block waiting-price"
        fxLayout="row wrap"
        fxLayoutAlign="center end"
      >
        <div class="logo">
          <img src="../../../../../assets/image/medal.svg" alt="" />
        </div>
        <div class="data">
          <div class="count">
            {{ (userReport | async)?.user_score || 0 }} امتیاز
          </div>
          <button class="label" mat-button color="primary">
            <div class="d-flex">
              <span>صفحه امتیازات</span>
              <jam-icon name="chevron-left" />
            </div>
          </button>
        </div>
      </div>

      <div
        class="info-block waiting-price"
        fxLayout="row wrap"
        fxLayoutAlign="center end"
      >
        <div class="logo">
          <img src="../../../../../assets/image/wallet1.svg" alt="" />
        </div>
        <div class="data">
          <div class="count">
            {{ (userReport | async)?.wallet_balance || 0 | digitsEnToFa }} تومان
          </div>
          <button
            [routerLink]="['wallet']"
            class="label"
            mat-button
            color="primary"
          >
            <div class="d-flex">
              <span>مشاهده کیف پول</span>
              <jam-icon name="chevron-left" />
            </div>
          </button>
        </div>
      </div>

      <div
        class="info-block waiting-price"
        fxLayout="row wrap"
        fxLayoutAlign="center end"
      >
        <div class="logo">
          <img src="../../../../../assets/image/progress.svg" alt="" />
        </div>
        <div class="data">
          <div class="count">۰ سفارش</div>
          <button class="label" mat-button color="primary">
            <div class="d-flex">
              <span>رهگیری مرسوله</span>
              <jam-icon name="chevron-left" />
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
